// extracted by mini-css-extract-plugin
export default {"content":"EditEachRecord_content__bm3Mj","tabs":"EditEachRecord_tabs__-TYNL","sticky-footer":"EditEachRecord_sticky-footer__Whg4V"};